import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import FileSaver from 'file-saver';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import OutbOrd04Actions, { OutbOrd04Types } from '../Stores/OutbOrd04/Actions';

const getAppStore = state => state.app;

export function* outbOrd04FetchOutbOrd04({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(OutbOrd04Actions.outbOrd04FetchOutbOrd04Loading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `outbOrd/indexProcess/OUTB_ORD_04/${app.curDivisionId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        OutbOrd04Actions.outbOrd04FetchOutbOrd04Success(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(OutbOrd04Actions.outbOrd04FetchOutbOrd04Loading(false));
  }
}

export function* outbOrd04CreateOutbOrd04({ hdrIds }) {
  try {
    yield put(OutbOrd04Actions.outbOrd04CreateOutbOrd04Loading(true));

    const app = yield select(getAppStore);

    const postData = {
      hdrIds
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `outbOrd/createProcess/OUTB_ORD_04`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(OutbOrd04Actions.outbOrd04CreateOutbOrd04Success(result.data));

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(OutbOrd04Actions.outbOrd04CreateOutbOrd04Loading(false));
  }
}

export function* outbOrd04GoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/prodOrdDetail/update/${hdrId}`));
}

export function* outbOrd04NewDocument() {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/prodOrdDetail/create/${app.curDivisionId}`));
}

export function* outbOrd04CheckStock({ hdrIds }) {
  try {
    yield put(OutbOrd04Actions.outbOrd04CreateOutbOrd04Loading(true));

    const app = yield select(getAppStore);

    const getData = {
      hdrIds
    };

    const result = yield call(
      ApiService.downloadGetApi, // function
      app.apiUrl,
      `prodOrd/checkStock`,
      app.token,
      getData,
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    );

    if (result.isSuccess === true) {
      FileSaver.saveAs(result.data, 'CHECK_STOCK.XLSX');
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(OutbOrd04Actions.outbOrd04CreateOutbOrd04Loading(false));
  }
}

export const saga = [
  takeLatest(OutbOrd04Types.OUTB_ORD04_FETCH_OUTB_ORD04, outbOrd04FetchOutbOrd04),
  takeLatest(OutbOrd04Types.OUTB_ORD04_CREATE_OUTB_ORD04, outbOrd04CreateOutbOrd04),
  takeLatest(OutbOrd04Types.OUTB_ORD04_GO_TO_DOCUMENT, outbOrd04GoToDocument),
  takeLatest(OutbOrd04Types.OUTB_ORD04_NEW_DOCUMENT, outbOrd04NewDocument),
  takeLatest(OutbOrd04Types.OUTB_ORD04_CHECK_STOCK, outbOrd04CheckStock)
];
